import { BadgeProps } from "@mui/material";
import { ReactNode, forwardRef } from "react";

import MDBadgeRoot from "./MDBadgeRoot";

type MDBadgeProps = Omit<BadgeProps, "color"> & {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
  variant?: "gradient" | "contained";
  size?: "xs" | "sm" | "md" | "lg";
  circular?: boolean;
  indicator?: boolean;
  border?: boolean;
  children?: ReactNode;
  container?: boolean;
};

const MDBadge = forwardRef<HTMLSpanElement, MDBadgeProps>(
  (
    {
      color = "dark",
      variant = "gradient",
      size = "sm",
      circular = false,
      indicator = false,
      border = false,
      container = false,
      children,
      ...rest
    },
    ref
  ) => {
    const ownerState = {
      color: color as
        | "primary"
        | "secondary"
        | "info"
        | "success"
        | "warning"
        | "error"
        | "light"
        | "dark",
      variant: variant as "gradient" | "contained",
      size,
      circular,
      indicator,
      border,
      container,
      children,
    };

    return (
      <MDBadgeRoot {...rest} ownerState={ownerState} ref={ref} color="default">
        {children}
      </MDBadgeRoot>
    );
  }
);

MDBadge.displayName = "MDBadge";
export default MDBadge;
